module.exports = __webpack_public_path__ + "static/media/Montserrat-Regular.430be0dd.ttf";